import { render } from "./FullScreenSliderComp.vue?vue&type=template&id=bd0152d6&scoped=true"
import script from "./FullScreenSliderComp.vue?vue&type=script&lang=js"
export * from "./FullScreenSliderComp.vue?vue&type=script&lang=js"

import "./FullScreenSliderComp.vue?vue&type=style&index=0&id=bd0152d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0152d6"]])

export default __exports__